import {Feedback, ViewMode} from '../../../constants/dataEnum';
import {hideLoading, hideSnackbar, showSnackbar} from '../../actions/appStateAction';
import {hideRuntimeDialog} from '../../actions/runtimeStateAction';
import {resolveIntl} from '../commonBusiness';
import {showModalConnectionLost} from '../commonModalBusiness';
import {saveProtocol} from '../protocolManagementBusiness';

const intl = resolveIntl();

export const subscribeEvent = (hubObject) => (dispatch, getState) => {
  hubObject.onclose(() => {
    console.log('connection is closed - authoring hub');
    const {appState, aboutState} = getState();
    const {viewMode, isRestoringSoftware} = appState;
    const {isFinalizing, isDowngrading} = aboutState;

    if ((viewMode === ViewMode.ABOUT && isFinalizing) || isDowngrading || isRestoringSoftware) {
      return;
    }

    dispatch(hideSnackbar());
    dispatch(hideLoading());
    dispatch(showModalConnectionLost());
  });

  hubObject.onreconnecting(() => {
    console.log('onreconnecting...');
    const {aboutState, appState} = getState();
    const {isFinalizing, isDowngrading} = aboutState;
    const {isRestoringSoftware} = appState;

    if (isFinalizing || isDowngrading || isRestoringSoftware) {
      return;
    }

    dispatch(hideLoading());
    dispatch(hideRuntimeDialog());
    dispatch(showSnackbar(Feedback.INFO, intl.formatMessage({id: 'connection.message.onreconnecting'})));
  });

  hubObject.onreconnected(() => {
    console.log('onreconnected!');
    const {appState} = getState();
    const {viewMode} = appState;

    dispatch(hideSnackbar());
    if (viewMode === ViewMode.PROTOCOL_EDITOR) {
      dispatch(saveProtocol());
    }
  });
};

export default subscribeEvent;
